import {WITH_AUTH_ADMIN_PATHS} from 'consts/paths'
import type {RouteParams} from 'types/routes'
import {Create} from 'pages/withAuth/adminPage/documents/employees/contracts/create'
import {Show} from 'pages/withAuth/adminPage/documents/employees/contracts/show'

export const ContractRoutes: RouteParams[] = [
  {
    key: 'documents/employees/:id/contracts/create',
    path: WITH_AUTH_ADMIN_PATHS.DOCUMENTS.EMPLOYEES.CONTRACTS.CREATE,
    component: Create,
    exact: true,
    whiteList: ['full_admin', 'office_admin', 'limited_admin'],
  },
  {
    key: 'documents/employees/:id/contracts/show',
    path: WITH_AUTH_ADMIN_PATHS.DOCUMENTS.EMPLOYEES.CONTRACTS.SHOW,
    component: Show,
    exact: true,
    whiteList: ['full_admin', 'office_admin', 'limited_admin'],
  },
]
